import { BaseAction } from "../../../core/actions/BaseAction";
import { _eventBus } from "../../../core/events/EventBus";
import { IGetEnhancedTripActionParams } from "../../../Orchestrator/Types/Interface/ICmsEnhancedTrip";

class EnhancedTripCardClickAction extends BaseAction<void, IGetEnhancedTripActionParams> {
    override async run(): Promise<void> {
        const { slug } = this.params!;
        _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: `/enhanced-trips/${slug}`,
        })
    }
}

export const enhancedTripCardClickAction = new EnhancedTripCardClickAction();
